export default "__VITE_ASSET__Bv9v5iQU__"